/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AdminMeetingResponse,
  AdminRegistrationDetail,
  CommunityMeetingDetail,
  EIRMeetingDetail,
  GetCommunityMeetingDetailParams,
  GetEirMeetingDetailParams,
  GetMeetingsParams,
  GetRegistrationsDownloadDataParams,
  HTTPValidationError,
  RefreshMeetingParams,
  RefreshMeetingsRequest,
  UpdateAttendanceParams,
  UpdateMeetingsResponse,
  UpdateNotesRequest,
} from './platformapi.schemas';

import getMeetingsMutator from '../custom-axios-instance';
import getCommunityMeetingDetailMutator from '../custom-axios-instance';
import getEirMeetingDetailMutator from '../custom-axios-instance';
import updateRegistrantNotesMutator from '../custom-axios-instance';
import refreshMeetingMutator from '../custom-axios-instance';
import refreshMeetingsByDateMutator from '../custom-axios-instance';
import getRegistrationsDownloadDataMutator from '../custom-axios-instance';
import updateAttendanceMutator from '../custom-axios-instance';

/**
 * Get all meetings
 * @summary Get Meetings
 */
export const getMeetings = (params?: GetMeetingsParams, signal?: AbortSignal) => {
  return getMeetingsMutator<AdminMeetingResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/meetings/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetMeetingsQueryKey = (params?: GetMeetingsParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/meetings/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetMeetingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMeetings>>,
  TError = HTTPValidationError,
>(
  params?: GetMeetingsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetings>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeetingsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMeetings>>> = ({ signal }) =>
    getMeetings(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMeetings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMeetingsQueryResult = NonNullable<Awaited<ReturnType<typeof getMeetings>>>;
export type GetMeetingsQueryError = HTTPValidationError;

export function useGetMeetings<
  TData = Awaited<ReturnType<typeof getMeetings>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetMeetingsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetings>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeetings>>,
          TError,
          Awaited<ReturnType<typeof getMeetings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMeetings<
  TData = Awaited<ReturnType<typeof getMeetings>>,
  TError = HTTPValidationError,
>(
  params?: GetMeetingsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetings>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMeetings>>,
          TError,
          Awaited<ReturnType<typeof getMeetings>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMeetings<
  TData = Awaited<ReturnType<typeof getMeetings>>,
  TError = HTTPValidationError,
>(
  params?: GetMeetingsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetings>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Meetings
 */

export function useGetMeetings<
  TData = Awaited<ReturnType<typeof getMeetings>>,
  TError = HTTPValidationError,
>(
  params?: GetMeetingsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getMeetings>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetMeetingsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get meeting details and filtered, paginated participant data
 * @summary Get Community Meeting Detail
 */
export const getCommunityMeetingDetail = (
  params: GetCommunityMeetingDetailParams,
  signal?: AbortSignal,
) => {
  return getCommunityMeetingDetailMutator<CommunityMeetingDetail>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/meetings/community_details`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetCommunityMeetingDetailQueryKey = (params: GetCommunityMeetingDetailParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/meetings/community_details`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetCommunityMeetingDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof getCommunityMeetingDetail>>,
  TError = HTTPValidationError,
>(
  params: GetCommunityMeetingDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunityMeetingDetail>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCommunityMeetingDetailQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommunityMeetingDetail>>> = ({
    signal,
  }) => getCommunityMeetingDetail(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCommunityMeetingDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCommunityMeetingDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCommunityMeetingDetail>>
>;
export type GetCommunityMeetingDetailQueryError = HTTPValidationError;

export function useGetCommunityMeetingDetail<
  TData = Awaited<ReturnType<typeof getCommunityMeetingDetail>>,
  TError = HTTPValidationError,
>(
  params: GetCommunityMeetingDetailParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunityMeetingDetail>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommunityMeetingDetail>>,
          TError,
          Awaited<ReturnType<typeof getCommunityMeetingDetail>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCommunityMeetingDetail<
  TData = Awaited<ReturnType<typeof getCommunityMeetingDetail>>,
  TError = HTTPValidationError,
>(
  params: GetCommunityMeetingDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunityMeetingDetail>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommunityMeetingDetail>>,
          TError,
          Awaited<ReturnType<typeof getCommunityMeetingDetail>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCommunityMeetingDetail<
  TData = Awaited<ReturnType<typeof getCommunityMeetingDetail>>,
  TError = HTTPValidationError,
>(
  params: GetCommunityMeetingDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunityMeetingDetail>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Community Meeting Detail
 */

export function useGetCommunityMeetingDetail<
  TData = Awaited<ReturnType<typeof getCommunityMeetingDetail>>,
  TError = HTTPValidationError,
>(
  params: GetCommunityMeetingDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCommunityMeetingDetail>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetCommunityMeetingDetailQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get meeting details and participant data for EIR calls
 * @summary Get Eir Meeting Detail
 */
export const getEirMeetingDetail = (params: GetEirMeetingDetailParams, signal?: AbortSignal) => {
  return getEirMeetingDetailMutator<EIRMeetingDetail>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/meetings/eir_details`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetEirMeetingDetailQueryKey = (params: GetEirMeetingDetailParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/meetings/eir_details`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetEirMeetingDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof getEirMeetingDetail>>,
  TError = HTTPValidationError,
>(
  params: GetEirMeetingDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEirMeetingDetail>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEirMeetingDetailQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEirMeetingDetail>>> = ({ signal }) =>
    getEirMeetingDetail(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEirMeetingDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetEirMeetingDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEirMeetingDetail>>
>;
export type GetEirMeetingDetailQueryError = HTTPValidationError;

export function useGetEirMeetingDetail<
  TData = Awaited<ReturnType<typeof getEirMeetingDetail>>,
  TError = HTTPValidationError,
>(
  params: GetEirMeetingDetailParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEirMeetingDetail>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEirMeetingDetail>>,
          TError,
          Awaited<ReturnType<typeof getEirMeetingDetail>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEirMeetingDetail<
  TData = Awaited<ReturnType<typeof getEirMeetingDetail>>,
  TError = HTTPValidationError,
>(
  params: GetEirMeetingDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEirMeetingDetail>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEirMeetingDetail>>,
          TError,
          Awaited<ReturnType<typeof getEirMeetingDetail>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEirMeetingDetail<
  TData = Awaited<ReturnType<typeof getEirMeetingDetail>>,
  TError = HTTPValidationError,
>(
  params: GetEirMeetingDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEirMeetingDetail>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Eir Meeting Detail
 */

export function useGetEirMeetingDetail<
  TData = Awaited<ReturnType<typeof getEirMeetingDetail>>,
  TError = HTTPValidationError,
>(
  params: GetEirMeetingDetailParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEirMeetingDetail>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetEirMeetingDetailQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update notes for a specific registrant
 * @summary Update Registrant Notes
 */
export const updateRegistrantNotes = (
  updateNotesRequest: UpdateNotesRequest,
  signal?: AbortSignal,
) => {
  return updateRegistrantNotesMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/meetings/notes`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateNotesRequest,
    signal,
  });
};

export const getUpdateRegistrantNotesMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateRegistrantNotes>>,
    TError,
    { data: UpdateNotesRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateRegistrantNotes>>,
  TError,
  { data: UpdateNotesRequest },
  TContext
> => {
  const mutationKey = ['updateRegistrantNotes'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateRegistrantNotes>>,
    { data: UpdateNotesRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateRegistrantNotes(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateRegistrantNotesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateRegistrantNotes>>
>;
export type UpdateRegistrantNotesMutationBody = UpdateNotesRequest;
export type UpdateRegistrantNotesMutationError = HTTPValidationError;

/**
 * @summary Update Registrant Notes
 */
export const useUpdateRegistrantNotes = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateRegistrantNotes>>,
      TError,
      { data: UpdateNotesRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateRegistrantNotes>>,
  TError,
  { data: UpdateNotesRequest },
  TContext
> => {
  const mutationOptions = getUpdateRegistrantNotesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Refresh Meeting
 */
export const refreshMeeting = (params: RefreshMeetingParams, signal?: AbortSignal) => {
  return refreshMeetingMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/meetings/refresh_meeting`,
    method: 'POST',
    params,
    signal,
  });
};

export const getRefreshMeetingMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshMeeting>>,
    TError,
    { params: RefreshMeetingParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshMeeting>>,
  TError,
  { params: RefreshMeetingParams },
  TContext
> => {
  const mutationKey = ['refreshMeeting'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshMeeting>>,
    { params: RefreshMeetingParams }
  > = (props) => {
    const { params } = props ?? {};

    return refreshMeeting(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshMeetingMutationResult = NonNullable<Awaited<ReturnType<typeof refreshMeeting>>>;

export type RefreshMeetingMutationError = HTTPValidationError;

/**
 * @summary Refresh Meeting
 */
export const useRefreshMeeting = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof refreshMeeting>>,
      TError,
      { params: RefreshMeetingParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof refreshMeeting>>,
  TError,
  { params: RefreshMeetingParams },
  TContext
> => {
  const mutationOptions = getRefreshMeetingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Refresh all EIR and Community user meetings by date
 * @summary Refresh Meetings By Date
 */
export const refreshMeetingsByDate = (
  refreshMeetingsRequest: RefreshMeetingsRequest,
  signal?: AbortSignal,
) => {
  return refreshMeetingsByDateMutator<UpdateMeetingsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/meetings/refresh_meetings_by_date`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: refreshMeetingsRequest,
    signal,
  });
};

export const getRefreshMeetingsByDateMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshMeetingsByDate>>,
    TError,
    { data: RefreshMeetingsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshMeetingsByDate>>,
  TError,
  { data: RefreshMeetingsRequest },
  TContext
> => {
  const mutationKey = ['refreshMeetingsByDate'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshMeetingsByDate>>,
    { data: RefreshMeetingsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return refreshMeetingsByDate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshMeetingsByDateMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshMeetingsByDate>>
>;
export type RefreshMeetingsByDateMutationBody = RefreshMeetingsRequest;
export type RefreshMeetingsByDateMutationError = HTTPValidationError;

/**
 * @summary Refresh Meetings By Date
 */
export const useRefreshMeetingsByDate = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof refreshMeetingsByDate>>,
      TError,
      { data: RefreshMeetingsRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof refreshMeetingsByDate>>,
  TError,
  { data: RefreshMeetingsRequest },
  TContext
> => {
  const mutationOptions = getRefreshMeetingsByDateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get filtered meeting registrations for download
 * @summary Get Registrations Download Data
 */
export const getRegistrationsDownloadData = (
  params: GetRegistrationsDownloadDataParams,
  signal?: AbortSignal,
) => {
  return getRegistrationsDownloadDataMutator<AdminRegistrationDetail[]>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/meetings/registrations_download`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetRegistrationsDownloadDataQueryKey = (
  params: GetRegistrationsDownloadDataParams,
) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/meetings/registrations_download`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetRegistrationsDownloadDataQueryOptions = <
  TData = Awaited<ReturnType<typeof getRegistrationsDownloadData>>,
  TError = HTTPValidationError,
>(
  params: GetRegistrationsDownloadDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRegistrationsDownloadData>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRegistrationsDownloadDataQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRegistrationsDownloadData>>> = ({
    signal,
  }) => getRegistrationsDownloadData(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getRegistrationsDownloadData>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetRegistrationsDownloadDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRegistrationsDownloadData>>
>;
export type GetRegistrationsDownloadDataQueryError = HTTPValidationError;

export function useGetRegistrationsDownloadData<
  TData = Awaited<ReturnType<typeof getRegistrationsDownloadData>>,
  TError = HTTPValidationError,
>(
  params: GetRegistrationsDownloadDataParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRegistrationsDownloadData>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegistrationsDownloadData>>,
          TError,
          Awaited<ReturnType<typeof getRegistrationsDownloadData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRegistrationsDownloadData<
  TData = Awaited<ReturnType<typeof getRegistrationsDownloadData>>,
  TError = HTTPValidationError,
>(
  params: GetRegistrationsDownloadDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRegistrationsDownloadData>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRegistrationsDownloadData>>,
          TError,
          Awaited<ReturnType<typeof getRegistrationsDownloadData>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetRegistrationsDownloadData<
  TData = Awaited<ReturnType<typeof getRegistrationsDownloadData>>,
  TError = HTTPValidationError,
>(
  params: GetRegistrationsDownloadDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRegistrationsDownloadData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Registrations Download Data
 */

export function useGetRegistrationsDownloadData<
  TData = Awaited<ReturnType<typeof getRegistrationsDownloadData>>,
  TError = HTTPValidationError,
>(
  params: GetRegistrationsDownloadDataParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getRegistrationsDownloadData>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetRegistrationsDownloadDataQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update attendance for a specific registrant
 * @summary Update Attendance
 */
export const updateAttendance = (params: UpdateAttendanceParams, signal?: AbortSignal) => {
  return updateAttendanceMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/meetings/update_attendance`,
    method: 'POST',
    params,
    signal,
  });
};

export const getUpdateAttendanceMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAttendance>>,
    TError,
    { params: UpdateAttendanceParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAttendance>>,
  TError,
  { params: UpdateAttendanceParams },
  TContext
> => {
  const mutationKey = ['updateAttendance'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAttendance>>,
    { params: UpdateAttendanceParams }
  > = (props) => {
    const { params } = props ?? {};

    return updateAttendance(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAttendanceMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAttendance>>
>;

export type UpdateAttendanceMutationError = HTTPValidationError;

/**
 * @summary Update Attendance
 */
export const useUpdateAttendance = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAttendance>>,
      TError,
      { params: UpdateAttendanceParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateAttendance>>,
  TError,
  { params: UpdateAttendanceParams },
  TContext
> => {
  const mutationOptions = getUpdateAttendanceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
